const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = window.document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const DATA = [
  { // 0
    title1: `Select Goals`,
    desc: [`Build a personalized growth journey for yourself:`,],
    ul: [
      {
        bold: `Select Focus Areas: `,
        desc: `You can select up to 2 Focus Areas at any time. Being focused on key priorities increases the chance of achievement.`,
      },
      {
        bold: `Select Goals: `,
        desc: `You can select one goal under each Focus Area. The selected goals will open up relevant services you can choose from.`,
      },
      {
        bold: `Choose Services: `,
        desc: `You can select the service that feels right for you in the current moment, from the various options available:`,
        list: [
          {
            bold: `Self: `,
            desc: `These services are the ones you can work by yourself. These include our proprietary Self-action Learning Modules and Assessments. You can also download our app to work with your own Hanie (Happiness Genie).`,
          },
          {
            bold: `Experts: `,
            desc: `Find the best professionals who can work with you on one-on-one (1:1) basis to help you achieve your goals. These experts come from a variety of fields like Coaching, Therapy, Psychology, Fitness, Art, Finance etc.`,
          },
          {
            bold: `Community: `,
            desc: `Networking and brand building simplified through our Mobile App. Find Say Cheese users who have similar goals, or those who are good at what you want to achieve. Set up Private conversations with them on our app. You can also offer your expertise through 1:1 conversations, organizing Public conversations or participating in other Public conversations already happening.`,
          },
        ]
      },
    ],
    buttonText1: `Get Started`,
    buttonLink1: `personalisation`,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Select Goals.webp`,
  },

  { // 1
    title1: `Modules`,
    desc: [
      `Research shows that passive content consumption for learning is very ineffective in the learner’s development. Moreover, a very small fraction of learners actually completes such learning programs. That is where Say Cheese comes in.`,
      `Our learning modules are action-oriented programs built by our team of industry leaders, psychologists and researchers to bring simple yet powerful and effective concepts to life, in a unique and easy-to-learn and apply manner. A key differentiator of our modules is that they help you actively engage and personalise the solutions to your needs and life experiences.`,
      `Additionally, we carefully select the topics across career, health and relationships so that you can get holistic learning opportunity across various facets of life with high quality actionable content in one place.`,
      `Happy Learning!`,
    ],
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Modules.webp`,
    buttonText1: `See all modules`,
    buttonLink1: `self-learning`,
  },

  { // 2
    title1: `Assessments`,
    desc: [
      `Do you want to be happier, more successful, in better control, make faster progress? Self-assessment is a great way to develop better self-awareness, which can clear the fog for the path to become visible, towards becoming a better version of yourself with multiple other benefits you aspire for.`,
      `Our proprietary assessment – HER (Happiness Evaluation Report) helps you give a better understanding on various dimensions on our Happiness Model and prioritize the focus areas to get started towards a better you.`,
      `Over 4000 women have already taken HER and identified their top focus areas. What are you waiting for?`,
    ],
    subtitle2: `Customer Love`,
    desc_more: [
      `Our users have loved the insightful yet simple and engaging format of the assessment. It has helped them develop a better understanding of themselves which enables action. Here is some feedback from our users:`,
    ],
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Assessment.webp`,    
    buttonText1: `Take HER Assessment`,
    buttonLink1: `my-happiness-index`,
    image_last: `${process.env.PUBLIC_URL}/assets/images/myplace/customer_love.webp`,    
  },

  { // 3
    title1: `Hanie Room`,
    desc: [
      `It is a proven fact that we can generate tremendous benefits through our own self. Whether it is reflection, meditation, just spending some me-time, being able to see yourself in different situations and moods, letting your steam off, or sometimes just talking to yourself, it can really elevate how you are feeling.`,
      `Hanie Room is your private and safe place to be with yourself, with your Hanie (Happiness Genie) to unlock the power within you. This one of its kind functionality is only available on the Say Cheese Mobile App. Download the app and explore with your Hanie.`,
    ],
    appLink1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Hanie.webp`,    
  },

  { // 4
    title1: `Experts`,
    desc: [
      `We all can benefit from expert help. Whether you want to improve your performance, change your career path, improve relationships, or improve your wellbeing, we have best-in-class experts for you.`,
      `Set up 1:1 session with the selected expert, in a safe and private space created especially for your trust and comfort on our Mobile App. Say Cheese brings together top-quality professionals and experts across a variety of categories like Coaching (Life, Business, Relationship etc), Mentoring, Counselling, Therapy, Fitness, Mental Wellbeing, Finance, Personal Branding to name a few. You don’t have to go to different platforms to find different services.`,
    ],
    buttonText1: `Find an Expert (Seek)`,
    buttonLink1: `https://serviceecom.devsaycheese.com/`,
    link1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Experts.webp`,    
  },

  { // 5
    title1: `Become A Giver`,
    desc: [
      `While we all need support in certain areas, each one of us has strengths and expertise as well. The world needs what you are good at. Become a Giver!`,
    ],
    buttonText1: `Offer Expertise (Give)`,
    buttonLink1: `https://devsaycheese.com/register/?onboarding=true`,
    link1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Giver.webp`,    
  },

  { // 6
    title1: `Community`,
    desc: [
      `Join a trusted, safe and one of its kind women-powered community to grow and help other women grow. The world will no more be divided between the haves and have-nots of capabilities. Break the barriers with Say Cheese. Meet people like you and also learn from people who are not like you but complement you. Connect beyond connections to have meaningful conversations, network, build beautiful relationships and grow your brand & influence. Discover new people with Selective Networking at your convenience or through our unique Speed Networking sessions.`,
      `Your Network is your Networth.`,
    ],
    appLink1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Community.webp`,    
  },
  
  { // 7
    title1: `Become an Evangelist`,
    desc: [
      `Are you as passionate as us to help women grow and become happier? Would you like to play a larger role to make a bigger difference?`,
      `If yes, share your interest to become a Say Cheese Evangelist and how you can contribute. We will connect with you to explore it further.`,
    ],
    buttonText1: `I'm interested!`,
    buttonLink1: `https://docs.google.com/forms/d/1WyZ3ZSNI_77qjFPCBV-0P7uMamsKWOtusd9SJZbhMNw/edit?usp=sharing`,
    link1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Evangalist.webp`,
    newpage: true, 
  },

  { // 8
    title1: `My Feedback`,
    desc: [
      `Here you can find the feedback given and received for each session. The feedback to the Giver can be given through the Say Cheese Mobile App at the end of the session. Your feedback helps other women make the right decision on selecting the best Giver for their goals.`,
    ],
    buttonText1: `See Feedback!`,
    buttonLink1: `seeker-feedback`,
  },

  { // 9
    title1: `Frenzcoins`,
    subtitle1: `Earn`,
    desc: [
      `Frenzcoins are loyalty rewards offered by Say Cheese when you complete certain activities on the platform as shown below. The more activities you carry out, the more Frenzcoins you earn. Please refer the earning table for list of activities and corresponding Frenzcoins.`,
    ],
    subtitle2: `Redeem`,
    desc_more: [
      `Right now you can redeem Frenzcoins on Say Cheese services like Self-action Learning Modules. We will be soon be launching opportunities to redeem Frenzcoins with other service providers online and offline. Please refer the redemption table for list of activities and corresponding Frenzcoins. Watch this space for more!`,
    ],
    frenzcoin: true,
  },

  { // 10
    title1: `Journey so far`,
    desc: [
      'Check out how long you have come on your growth path. It is sometimes good to look at the rear view mirror too.'
    ],
    buttonText1: `See the Journey`,
    buttonLink1: `personalisation?page=1`,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Journey so far.webp`,
  },

  { // 11
    title1: `Find a Job`,
    desc: [
      `Are you looking for a job that gives you better fulfilment? Are you looking for a place with a better fit, more inclusivity? We are working on launching Jobs next year with a very different experience to help drive successful and fulfilling careers. Help us understand more about your job search experience, current job experience and the kind of job/career that you are looking for. This will be a very useful input for us to help build the future of jobs.`
    ],
    buttonText1: `Share Experience`,
    buttonLink1: `https://docs.google.com/forms/d/1CTL2oQ2ANs1r0-zZeD5mkqve8BZibwgSG5JC7a_t4eo/edit`,
    link1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Find a job.webp`,    
  },

  { // 12
    title1: `Share a Job`,
    desc: [
      `Are you looking for a faster way to find the right talent that can positively contribute to the organization’s growth and success? Are you unhappy with your new hires more often?`,
      `If you are the hiring manager or part of the Talent Acquisition team, please let us know about your hiring experience. This will be a very useful input for us to help build the future of jobs.`,
    ],
    buttonText1: `Share Experience`,
    buttonLink1: `https://docs.google.com/forms/d/1RD6FoPgm6EWWK-MQvgMZ-P1VrlCYlq66z1XVr0M5UAA/edit`,
    link1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Share job.webp`,
  }
];

export const GIVERDATA = [
  { // 0
    title1: `Create Giver Account`,
    desc: [
      `To start offering your expertise on Say Cheese, you need to create a Giver Account. We will ask you to share more details about you, your expertise, your credentials, the kind of services you would like to offer, your bank details etc. Additionally, you will get a dedicated page as a Giver that takes your services online. You may also share this page link within your circle to start offering services through Say Cheese.`,
    ],
    buttonText1: `Get Started`,
    buttonLink1: `/register/?onboarding=true`,
    link1: true,
    giver: true,
  },

  { // 1
    title1: `View My Page`,
    desc: [
      `You can view your own page just the way it will be visible to a Seeker. You can then come back and edit the information as required, to make it more relevant and impactful from a Seeker’s perspective. You can also check out a Sample Giver Page, if you wish to take some ideas to get started.`
    ],
    buttonText1: `View My Page`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/dashboard/?t=${getCookie("token")}`,
    link1: true,
    giver: true,
  },

  { //2
    title1: `Edit My Page`,
    desc: [
      `Start building or edit your Giver page to make it more relevant and impactful from a Seeker’s perspective.`,
    ],
    buttonText1: `Edit My Page`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/dashboard/?t=${getCookie("token")}`,
    link1: true,
    giver: true,
  },

  { //3
    title1: `Modify Services`,
    desc: [
      `You can offer Free and Paid Master Classes, Training Programs and/or Workshops on Say Cheese as well as offer private one-on-one sessions to Seekers who wish for your dedicated time and expertise. You can easily add, edit or delete the services.`,
    ],
    buttonText1: `Modify Services`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/msclass-free/`,
    link1: true,
    giver: true,
  },

  { //4
    title1: `Master Classes (Free)`,
    desc: [
      `Add, edit or delete the Free Master Classes`,
    ],
    buttonText1: `Modify`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/msclass-free/`,
    link1: true,
    giver: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Masterclass.webp`,
  },

  { //5
    title1: `Master Classes (Paid)`,
    desc: [
      `Add, edit or delete the Paid Master Classes`,
    ],
    buttonText1: `Modify`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/msclass-paid/`,
    link1: true,
    giver: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Masterclass.webp`,
  },

  { //6
    title1: `One-on-one Sessions`,
    desc: [
      `Add, edit or delete the One-on-one Sessions`,
    ],
    buttonText1: `Modify`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/one-to-one/`,
    link1: true,
    giver: true,
  },

  { //7
    title1: `Community`,
    desc: [
      `Now with the Say Cheese App, you can get access to the entire Seeker Community of Say Cheese and connect with them through our unique Speed Networking sessions organized at specific frequency. You can also reach out to target users through our unique Broadcast Room. Grow your customer base in this unique way, only through the Say Cheese app.`,
      `You also need the App to conduct the one-on-one sessions booked by the Seekers with you. Download the app now!`
    ],
    giver: true,
    appLink1: true,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Community.webp`,    
  },

  { //8
    title1: `My Transactions`,
    buttonText1: `View Transactions`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/transactions/`,
    link1: true,
    giver: true,
  },

  { // 9
    subtitle1: `Session Feedback`,
    desc: [
      `After each one-on-one session, you are required to submit the feedback to the Seeker. This is a critical step to process the remittance of the completed session to your account.`
    ],
    subtitle2: `Seeker Ratings`,
    desc_more: [
      `After each session, the Seeker is asked for rating and feedback based on their experience with you. Please remember that very low ratings can impact your ability to offer services on the Say Cheese platform. Offering incentives to Seekers for higher ratings is against our policies.`
    ],
    buttonText1: `See Feedback`,
    buttonLink1: `https://serviceecom.devsaycheese.com/giver/onboarding/feedback/`,
    link1: true,
    giver: true,
  },

  { //10
    title1: `Journey so far`,
    buttonText1: `View journey`,
    buttonLink1: `personalisation?page=2`,
    image1: `${process.env.PUBLIC_URL}/assets/images/myplace/Journey so far.webp`,    
    link1: true,
    giver: true,
  },
];